import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Identicons from "react-identicons";
import { backProject, getOwnerReputation } from '../services/blockchain'
import { FaEthereum } from "react-icons/fa";
import {
  daysRemaining,
  setGlobalState,
  truncate,
  useGlobalState,
} from "../store";
import { payoutProject } from "../services/blockchain";
import { calculateBarPercentage, daysLeft } from "../utils";
import { FacebookShareButton, FacebookIcon, LinkedinShareButton, LinkedinIcon, TwitterShareButton, TwitterIcon, RedditShareButton, RedditIcon } from 'react-share';
// import BackProject from "./BackProject";
import RateProjectOwner from "./RateProjectOwner"

const CountBox = ({ title, value }) => {
  return (
    <div className="flex flex-col items-center w-[150px]">
      <h4 className="font-epilogue font-bold text-[30px] text-white p-3 bg-[#1c1c24] rounded-t-[10px] w-full text-center truncate">
        {value}
      </h4>
      <p className="font-epilogue font-normal text-[16px] text-[#808191] bg-[#28282e] px-3 py-2 w-full rouned-b-[10px] text-center">
        {title}
      </p>
    </div>
  );
};

const StatusBox = ({ title, project, expired }) => {
  return (
    <div className="flex flex-col items-center w-[150px]">
      {expired ? (
        <h4 className="text-red-500 font-epilogue font-bold text-[30px] p-3 bg-[#1c1c24] px-3 py-2 w-full rounded-t-[10px] text-center">
          Expired
        </h4>
      ) : project?.status == 0 ? (
        <h4 className="text-gray-500 font-epilogue font-bold text-[30px] p-3 bg-[#1c1c24] px-3 py-2 w-full rounded-t-[10px]] text-center">
          Open
        </h4>
      ) : project?.status == 1 ? (
        <h4 className="text-blue-500 font-epilogue font-bold text-[30px] p-3 bg-[#1c1c24] px-3 py-2 w-full rouned-t-[10px] text-center">
          Accepted
        </h4>
      ) : project?.status == 2 ? (
        <h4 className="text-gray-500 font-epilogue font-bold text-[30px] p-3 bg-[#1c1c24] px-3 py-2 w-full rouned-t-[10px] text-center">
          Reverted
        </h4>
      ) : project?.status == 3 ? (
        <h4 className="text-red-500 font-epilogue font-bold text-[30px] p-3 bg-[#1c1c24] px-3 py-2 w-full rouned-t-[10px] text-center">
          Deleted
        </h4>
      ) : (
        <h4 className="text-orange-500 font-epilogue font-bold text-[30px] p-3 bg-[#1c1c24] px-3 py-2 w-full rouned-t-[10px] text-center">
          Paid
        </h4>
      )}
      {/* <h4 className="font-epilogue font-bold text-[30px] text-white p-3 bg-[#1c1c24] rounded-t-[10px] w-full text-center truncate">
        {value}
      </h4> */}
      <p className="font-epilogue font-normal text-[16px] text-[#808191] bg-[#28282e] px-3 py-2 w-full rouned-b-[10px] text-center">
        {title}
      </p>
    </div>
  );
};

const CustomButton = ({ btnType, title, handleClick, styles }) => {
  return (
    <button
      type={btnType}
      className={`w-full text-white font-epilogue font-semibold text-[16px] leading-[26px] min-h-[52px] px-4 rounded-[10px] ${styles}`}
      onClick={handleClick}
    >
      {title}
    </button>
  );
};

const ProjectDetails = ({ project }) => {
  const [connectedAccount] = useGlobalState("connectedAccount");
  const [amount, setAmount] = useState("");
  const [reputation, setReputation] = useState(null);
  const expired = new Date().getTime() > Number(project?.expiresAt + "000");
  const remainingDays = daysLeft(Number(project?.expiresAt + "000"));
  const location = useLocation();
  const currentUrl = 'https://givehope.netlify.app' + location.pathname;
  const introMsg = 'Hi, found this initiative on GiveHope and would like you all to support within your capacity for this cause.';
  const fundingMsg = `We require ${project?.cost - project?.raised} in remaining ${remainingDays} days.`;

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log("fund")
    if (!amount) return

    await backProject(project?.id, amount)
    toast.success('Project backed successfully, will reflect in 30sec.')
  }

  const fetchOwnerReputation = async (projectOwner) => {
    try {
      const reputation = await getOwnerReputation(projectOwner);
      setReputation(reputation?.overallScore.toNumber())
      // Process the reputation data or update the state
    } catch (error) {
      reportError(error);
    }
  };
  
  useEffect(() => {
    if (project) {
      fetchOwnerReputation(project?.owner);
    }
  }, []); // Empty dependency array ensures the effect runs only once


  return (
    <div className="p-5 m-2">
      <div className="w-full flex md:flex-row flex-col mt-20 gap-[30px]">
        <div className="flex-1 flex-col">
          <img
            src={project?.imageURL}
            alt={project?.title}
            className="w-full h-[450px] object-cover rounded-xl"
          />
          <div className="relative w-full h-[5px] bg-[#3a3a43] mt-2">
            <div
              className="absolute h-full bg-[#4acd8d]"
              style={{
                width: `${calculateBarPercentage(
                  project?.cost,
                  project?.raised
                )}%`,
                maxWidth: "100%",
              }}
            ></div>
          </div>
          {/* <div className="flex justify-between items-center font-bold mt-2">
              <small>{project?.raised} ETH Raised</small>
              <small className="flex justify-start items-center">
              <FaEthereum />
              <span>{project?.cost} ETH</span>
              </small>
            </div> */}
        </div>

        <div className="flex md:w-[150px] w-full flex-wrap justify-between gap-[10px]">
          <CountBox title="Days Left" value={remainingDays} />
          <CountBox
            title={`Raised of ${project?.cost}`}
            value={project?.raised}
          />
          <CountBox title="Total Backers" value={project?.backers} />
          <StatusBox title="Status" project={project} expired={expired} />
        </div>
      </div>
      <div className="flex flex-col justify-start flex-wrap">
        <h5 className="text-gray-900 text-4xl font-medium mt-4 mb-4">
          {project?.title}
        </h5>
      </div>

      <div className="mt-[20px] flex lg:flex-row flex-col gap-5">
        <div className="flex-[2] flex flex-col gap-[40px]">
          <div className="flex">
            <div className="w-3/5">
              <h4 className="font-epilogue font-semibold text-[18px] uppercase">
                Creator
              </h4>

              <div className="mt-[20px] flex flex-row items-center flex-wrap gap-[14px]">
                <div className="w-[52px] h-[52px] flex items-center justify-center rounded-full bg-[#2c2f32] cursor-pointer">
                  <Identicons
                    className="rounded-full shadow-md"
                    string={project?.owner}
                    size={30}
                  />
                  {/* <img src={thirdweb} alt="user" className="w-[60%] h-[60%] object-contain"/> */}
                </div>
                <div>
                  <h4 className="font-epilogue font-semibold text-[16px] break-all">
                    {project?.owner}
                  </h4>
                  {/* <p className="mt-[4px] font-epilogue font-normal text-[14px] text-[#808191]"> */}
                  <p className="mt-[4px] font-epilogue font-normal text-[16px] text-gray-900">
                    <span className=' text-orange-400 font-bold'>10 </span>Campaigns | Reputation: <span className=' text-orange-400 font-bold'>{reputation}</span>
                  </p>
                  {/* <p>reputation: {reputation}</p> */}
                </div>
              </div>
            </div>
            
            {connectedAccount != project?.owner && (
              <div className="w-2/5">
                <div className="mt-[50px] flex flex-row justify-around items-center gap-[8px]">
                  {project?.status == 0 ? (
                    <>
                      <CustomButton
                        btnType="button"
                        styles="inline-block bg-blue-600 shadow-md hover:bg-blue-700"
                        handleClick={() => setGlobalState("backModal", "scale-100")}
                        title={"Back Project"}
                      />

                      <CustomButton
                        btnType="button"
                        styles="inline-block bg-blue-600 shadow-md hover:bg-blue-700"
                        handleClick={() => setGlobalState("rateModal", "scale-100")}
                        title={"Rate Owner"}
                      />
                    </>
                  ) : null}
                  </div>
              </div>
            )}

            {connectedAccount == project?.owner && (
              <div className="w-2/5">
                {/* For Testing
                <p className="mt-[4px] font-epilogue font-normal text-[12px] text-[#808191]">{address}</p> */}
                <div className="mt-[50px] flex flex-row justify-around items-center gap-[8px]">
                  {/* <CustomButton
                    btnType="button"
                    title="Close"
                    styles="w-full bg-[#8c6dfd]"
                  />
                  <CustomButton
                    btnType="button"
                    title="Edit"
                    styles="w-full bg-green-500"
                  />
                  <CustomButton
                    btnType="button"
                    title="Delete"
                    styles="w-full bg-orange-400"
                  /> */}
                  {/* {project?.status == 0 ? (
                    <>
                      <CustomButton
                        btnType="button"
                        styles="inline-block bg-blue-600 shadow-md hover:bg-blue-700"
                        handleClick={() => setGlobalState("backModal", "scale-100")}
                        title={"Back Project"}
                      />
                    </>
                  ) : null} */}

                  {connectedAccount == project?.owner ? (
                    project?.status != 3 ? (
                      project?.status == 1 ? (
                        <CustomButton
                          btnType="button"
                          styles="inline-block bg-orange-600 shadow-md hover:bg-orange-700"
                          handleClick={() => payoutProject(project?.id)}
                          title="Payout"
                        />
                      ) : project?.status != 4 ? (
                        <>
                          <CustomButton
                            btnType="button"
                            styles="inline-block bg-gray-600 shadow-md hover:bg-gray-700"
                            handleClick={() =>setGlobalState("updateModal", "scale-100")}
                            title="Edit"
                          />
                          <CustomButton
                            btnType="button"
                            styles="inline-block bg-red-600 shadow-md hover:bg-red-700"
                            handleClick={() =>setGlobalState("deleteModal", "scale-100")}
                            title="Delete"
                          />
                          <CustomButton
                            btnType="button"
                            styles="inline-block bg-blue-600 shadow-md hover:bg-blue-700"
                            handleClick={() =>setGlobalState("milestoneModal", "scale-100")}
                            title="Add Milestone"
                          />
                        </>
                      ) : (
                        <CustomButton
                          btnType="button"
                          styles="inline-block bg-gray-600 shadow-md hover:bg-gray-700"
                          title="Project Closed"
                        />
                      )
                    ) : null
                  ) : null}
                </div>
              </div>
            )}
          </div>

          {/* Story */}
          <div>
            <h4 className="font-epilogue font-semibold text-[18px] uppercase">
              Story
            </h4>

            <div className="mt-[20px]">
              <p className="font-epilogue font-normal text-[16px] text-[#808191] leading-[26px] text-justify">
                {project?.description}
              </p>
            </div>
          </div>

          {/* Social Media Sharing */}
          <div>
            <h4 className="font-epilogue font-semibold text-[18px] uppercase">
              Share
            </h4>
            <div className="flex mt-3 gap-x-3">
              {/* `${introMsg} ${state.title} - ${state.description} ${fundingMsg}` */}
              <FacebookShareButton url={currentUrl} quote={'Hi there'} hashtag="#GiveHope">
                <FacebookIcon size={45} round />
              </FacebookShareButton>

              <TwitterShareButton url={currentUrl} title={project.title} summary={`${introMsg} ${project.title} - ${project.description} ${fundingMsg}`} hashtags={["GiveHope"]}>
                <TwitterIcon size={45} round />
              </TwitterShareButton>

              <RedditShareButton url={currentUrl} title={project.title}>
                <RedditIcon size={45} round />
              </RedditShareButton>

              {/* <LinkedinShareButton url={currentUrl} source={currentUrl} title={state.title} summary={`${introMsg} ${state.title} - ${state.description} ${fundingMsg}`}>
                <LinkedinIcon size={40} round />
              </LinkedinShareButton> */}

              {/* url=https%3A%2F%2Fgivehope.netlify.app%2Fcampaign-details%2FICU%2520for%2520Rural%2520Hospitals%2520in%2520India&
              mini=true&
              title=ICU%20for%20Rural%20Hospitals%20in%20India&
              summary=Hi%2C%20found%20this%20initiative%20on%20GiveHope%20and%20would%20like%20you%20all%20to%20support%20within%20your%20capacity%20for%20this%20cause.%20ICU%20for%20Rural%20Hospitals%20in%20India%20-%20We%20are%20raising%20funds%20to%20upgrade%20and%20enhance%20the%20hospital%20infrastructure%20%26%20healthcare%20services%20to%20rural%20people.%20We%20are%20providing%20affordable%20and%20accessible%20services%20to%20the%20marginal%20%26%20tribal%20populations.%20We%20require%200.48%20in%20remaining%20undefined%20days.&
              source=https%3A%2F%2Fgivehope.netlify.app%2Fcampaign-details%2FICU%2520for%2520Rural%2520Hospitals%2520in%2520India */}
            </div>
          </div>

          {/* <div>
            <h4 className="font-epilogue font-semibold text-[18px] text-white uppercase">Donators</h4>

              <div className="mt-[20px] flex flex-col gap-4">
                {donators.length > 0 ? donators.map((item, index) => (
                  <div key={`${item.donator}-${index}`} className="flex justify-between items-center gap-4">
                    <p className="font-epilogue font-normal text-[16px] text-[#b2b3bd] leading-[26px] break-ll">{index + 1}. {item.donator}</p>
                    <p className="font-epilogue font-normal text-[16px] text-[#808191] leading-[26px] break-ll">{item.donation}</p>
                  </div>
                )) : (
                  <p className="font-epilogue font-normal text-[16px] text-[#808191] leading-[26px] text-justify">No donators yet. Be the first one!</p>
                )}
              </div>
          </div> */}
        </div>

        {/* <div className="flex-1">
          <h4 className="font-epilogue font-semibold text-[18px] uppercase">
            Fund
          </h4>

          <div className="mt-[20px] flex flex-col p-4 bg-[#1c1c24] rounded-[10px]">
            <p className="font-epilogue fount-medium text-[20px] leading-[30px] text-center text-[#808191]">
              Fund the campaign
            </p>
            <div className="mt-[30px]">
              <input
                type="number"
                placeholder="ETH 0.1"
                step="0.01"
                className="w-full py-[10px] sm:px-[20px] px-[15px] outline-none border-[1px] border-[#3a3a43] bg-transparent font-epilogue text-white text-[18px] leading-[30px] placeholder:text-[#4b5264] rounded-[10px]"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                onClick={(e) => handleSubmit(e)}
              />

              <div className="my-[20px] p-4 bg-[#13131a] rounded-[10px]">
                <h4 className="font-epilogue font-semibold text-[14px] leading-[22px] text-white">
                  Back it because you believe in it.
                </h4>
                <p className="mt-[20px] font-epilogue font-normal leading-[22px] text-[#808191]">
                  Support the project for no reward, just because it speaks to
                  you.
                </p>
              </div>

              <CustomButton
                btnType="button"
                title="Fund Campaign"
                styles="w-full bg-[#8c6dfd]"
              />
            </div>
          </div>
        </div> */}
      </div>

      {/* original */}
      <div className="flex-1 justify-center flex-col">
        <div className="flex justify-start items-start sm:space-x-4 flex-wrap">
          {/* <img
            src={project?.imageURL}
            alt={project?.title}
            className="w-full h-[410px] object-cover rounded-xl"
          /> */}

          <div className="flex-1 sm:py-0 py-4">
            {/* <div className="flex flex-col justify-start flex-wrap">
              <h5 className="text-gray-900 text-3xl font-medium m-2">
                {project?.title}
              </h5>
              <small className="text-gray-500">
                {expired
                  ? 'Expired'
                  : daysRemaining(project.expiresAt) + ' left'}
              </small>
            </div> */}

            {/* <div className="flex justify-between items-center w-full pt-1">
              <div className="flex justify-start space-x-2">
                <Identicons
                  className="rounded-full shadow-md"
                  string={project?.owner}
                  size={15}
                />
                {project?.owner ? (
                  <small className="text-gray-700">
                    {truncate(project?.owner, 4, 4, 11)}
                  </small>
                ) : null}
                <small className="text-gray-500 font-bold">
                  {project?.backers} Backer{project?.backers == 1 ? '' : 's'}
                </small>
              </div>

              <div className="font-bold">
                {expired ? (
                  <small className="text-red-500">Expired</small>
                ) : project?.status == 0 ? (
                  <small className="text-gray-500">Open</small>
                ) : project?.status == 1 ? (
                  <small className="text-blue-500">Accepted</small>
                ) : project?.status == 2 ? (
                  <small className="text-gray-500">Reverted</small>
                ) : project?.status == 3 ? (
                  <small className="text-red-500">Deleted</small>
                ) : (
                  <small className="text-orange-500">Paid</small>
                )}
              </div>
            </div> */}

            <div>
              {/* <p className="text-sm font-light mt-2">{project?.description}</p> */}
              {/* <div className="w-full overflow-hidden bg-gray-300 mt-4">
                <div
                  className="bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-l-full h-1 overflow-hidden max-w-full"
                  style={{
                    width: `${(project?.raised / project?.cost) * 100}%`,
                  }}
                />
              </div> */}

              {/* <div className="flex justify-between items-center font-bold mt-2">
                <small>{project?.raised} ETH Raised</small>
                <small className="flex justify-start items-center">
                  <FaEthereum />
                  <span>{project?.cost} ETH</span>
                </small>
              </div> */}

              {/* <div className="flex justify-start items-center space-x-2 mt-4">
                {project?.status == 0 ? (
                  <>
                    <button
                      type="button"
                      className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-blue-700"
                      onClick={() => setGlobalState("backModal", "scale-100")}
                    >
                      Back Project
                    </button>

                    <CustomButton
                      btnType="button"
                      styles="inline-block bg-blue-600 shadow-md hover:bg-blue-700"
                      handleClick={() => setGlobalState("rateModal", "scale-100")}
                      title={"Rate Owner"}
                    />
                  </>
                ) : null}

                {connectedAccount == project?.owner ? (
                  project?.status != 3 ? (
                    project?.status == 1 ? (
                      <button
                        type="button"
                        className="inline-block px-6 py-2.5 bg-orange-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-orange-700"
                        onClick={() => payoutProject(project?.id)}
                      >
                        Payout
                      </button>
                    ) : project?.status != 4 ? (
                      <>
                        <button
                          type="button"
                          className="inline-block px-6 py-2.5 bg-gray-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-gray-700"
                          onClick={() =>
                            setGlobalState("updateModal", "scale-100")
                          }
                        >
                          Edit
                        </button>
                        <button
                          type="button"
                          className="inline-block px-6 py-2.5 bg-red-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-red-700"
                          onClick={() =>
                            setGlobalState("deleteModal", "scale-100")
                          }
                        >
                          Delete
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        className="inline-block px-6 py-2.5 bg-gray-600 text-white font-medium text-xs leading-tight uppercase rounded-full shadow-md hover:bg-gray-700"
                      >
                        Project Closed
                      </button>
                    )
                  ) : null
                ) : null}
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
